import React from 'react';

class Loading extends React.Component {

  render() {
    return (
      <div className="loading-page">
        <div className="loader"></div>
      </div>
    );
  }
}

export default Loading;